export default function getTrekPaymentReviewFactory(ajax) {
  return async function getTrekPaymentReview({ trekId }) {
    return ajax({
      resource: `trips/treks/${trekId}/review`,
      method: 'get',
    });
  };
}



// WEBPACK FOOTER //
// ./src/services/getTrekPaymentReview.js